import Input from "@/components/Input";
import Button from "@/components/Button";
import Table from "@/components/Table";
import HeaderColumn from "@/components/Table/table-header/HeaderColumn";
import HeaderColumnSort from "@/components/Table/table-header/HeaderColumnSort";
import BodyImageWithInfoColumn from "@/components/Table/table-body/BodyImageWithInfoColumn";
import NO_PROFILE_PIC from "@/assets/icons/avatar.svg";
import BodyColumn from "@/components/Table/table-body/BodyColumn";
import Pagination from "@/components/Pagination";
import "./style.scss";
import getTransferOwnershipInteractor from "@/@core/interactor/product/get-transfer-ownership";
import { ChangeEvent, useEffect, useState } from "react";
import { stringToDate } from "@/utils/date";
import { formatPrice } from "@/utils/number";

let debounceSearch: any;

const TransferTab = () => {
  const [search, setSearch] = useState<string>("");
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [transfers, setTransfers] = useState<any[]>([]);

  const getTransferOwnership = async (
    page = activePage,
    search: string = ""
  ) => {
    try {
      const response = await getTransferOwnershipInteractor({
        limit: 5,
        page,
        search,
        status: 3,
      });

      const {
        data: { data, pagination },
      } = response;

      setTransfers(data);

      if (pagination) {
        setActivePage(pagination.current_page);
        setTotalPage(pagination.last_page);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearch(val);

    clearTimeout(debounceSearch);
    debounceSearch = setTimeout(() => {
      getTransferOwnership(1, val);
    }, 500);
  };

  const onSearchEnter = (e: any) => {
    const keyCode = e.keyCode;
    const val = e.target.value;

    if (keyCode === 13) {
      clearTimeout(debounceSearch);
      getTransferOwnership(1, val);
    }
  };

  const onChangePagination = (e: any) => {
    setActivePage(e);
  };

  const resetFilter = () => {
    setSearch("");
    setActivePage(1);
  };

  useEffect(() => {
    getTransferOwnership(activePage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage]);

  return (
    <div className="transfer-tab-wrapper">
      <div className="table-control">
        <div>
          <label>Search for product</label>
          <Input
            style={{ width: "360px" }}
            value={search}
            withIcon
            type="search"
            placeholder="Search"
            onChange={onChangeSearch}
            onKeyDown={onSearchEnter}
          />
        </div>
        <div className="btn-wrapper">
          <Button
            onClick={resetFilter}
            label="Reset Filter"
            type="secondary"
            size="md"
          />
        </div>
      </div>

      <div className="table-section">
        <Table>
          <thead>
            <tr>
              <HeaderColumn label="Product" alignLabel="text-left" />
              <HeaderColumn label="Transfer to" alignLabel="text-left" />
              <HeaderColumn label="Serial Number" alignLabel="text-left" />
              <HeaderColumnSort
                label="Transfer Value"
                sortType={"asc"}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
              <HeaderColumnSort
                label="Transfer at"
                sortType={"asc"}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
              <HeaderColumnSort
                label="Unlink at"
                sortType={"asc"}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
            </tr>
          </thead>
          <tbody>
            {transfers.map((item, idx) => (
              <tr key={idx}>
                <BodyImageWithInfoColumn
                  width="200px"
                  imgSrc={
                    item.images[0]
                      ? `${process.env.REACT_APP_API_URL}/file/${item.images[0].path}`
                      : NO_PROFILE_PIC
                  }
                  roundedImg="20px"
                  textName={item?.product?.name}
                  textDesc={item?.product?.master_sku}
                />
                <BodyImageWithInfoColumn
                  width="200px"
                  imgSrc={
                    item.photo_profile
                      ? `${process.env.REACT_APP_API_URL}/file/${item.photo_profile}`
                      : NO_PROFILE_PIC
                  }
                  roundedImg="20px"
                  textName={item.requester_user.fullname}
                  textDesc={item.requester_user.email}
                />
                <BodyColumn
                  width="200px"
                  label={item.product_unit.serial_number}
                  alignLabel="text-center"
                  color="black"
                />
                <BodyColumn
                  width="150px"
                  label={`Rp. ${formatPrice(String(item.product.price))}` || ""}
                  alignLabel="text-left"
                  color="black"
                />
                <BodyColumn
                  width="150px"
                  label={stringToDate(item.created_at, "dd month yyyy")}
                  alignLabel="text-center"
                  color="black"
                />
                <BodyColumn
                  width="150px"
                  label=""
                  alignLabel="text-center"
                  color="black"
                />
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          activePage={totalPage}
          totalPage={activePage}
          onChange={onChangePagination}
        />
      </div>
    </div>
  );
};

export default TransferTab;
